var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 18 16.2609 12.4348 16.2609 8.26087C16.2609 4.80309 13.4578 2 10 2C6.54222 2 3.73914 4.80309 3.73914 8.26087C3.73914 12.4348 10 18 10 18Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 8.00013C12.0003 9.1047 11.1048 10.0001 10.0003 10.0001C8.89569 10.0001 8.00026 9.1047 8.00026 8.00013C8.00026 6.89556 8.89569 6.00013 10.0003 6.00013C11.1048 6.00013 12.0003 6.89556 12.0003 8.00013Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker2);
export default __webpack_public_path__ + "static/media/map-marker2.1304f8aabea7f7f16645c8867d74184c.svg";
export { ForwardRef as ReactComponent };